import styled from 'styled-components';

const Padding10 = styled.div`
  padding: 0 10px;
`;
export const ImageCover = styled.img`
  width: 100%;
  height: 150px;
  object-fit: cover;
  margin-bottom: 10px;
  @media only screen and (max-width: 767px) {
    margin-bottom: 20px;
  }
`;
export const ImageCoverFix = styled.div`
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  @media only screen and (max-width: 767px) {
    margin-bottom: 20px;
  }
`;
export const BoxProject = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxDistanceBtsMrt = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 50px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxFloor = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxTotalUnits = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxParkingLot = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxLaunchYear = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxCompletedYear = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxPackagePrice = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  height: 72px;
  @media only screen and (max-width: 767px) {
    /* height: 55px; */
  }
  @media only screen and (max-width: 320px) {
    /* height: 90px; */
    padding-right: 5px;
  }
`;
export const BoxPriceSqm = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  height: 72px;
  @media only screen and (max-width: 767px) {
    /* height: 75px; */
  }
  @media only screen and (max-width: 320px) {
    /* height: 90px; */
    padding-right: 5px;
  }
`;
export const BoxResalePrice = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 110px; */
  @media only screen and (max-width: 767px) {
    /* height: 90px; */
  }
  @media only screen and (max-width: 320px) {
    /* height: 125px; */
    padding-right: 5px;
  }
`;
export const BoxSlodAdmin = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxUnitsLeftAdmin = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    /* height: 50px; */
    padding-right: 5px;
  }
`;
export const BoxFuniture = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 60px; */
  @media only screen and (max-width: 320px) {
    /* height: 50px; */
    padding-right: 5px;
  }
`;
export const BoxUnitType = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  padding-right: 20px;
  margin-bottom: 25px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxCeilling = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxFacility = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  padding-right: 20px;
  margin-bottom: 25px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxSlinkingFund = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const BoxCommonFee = styled(Padding10)`
  text-align: ${(props) => props.textPosition || 'left'};
  background-color: ${(props) => props.bgColor || 'white'};
  padding-right: 20px;
  margin-bottom: 15px;
  /* height: 25px; */
  @media only screen and (max-width: 767px) {
    /* height: 35px; */
  }
  @media only screen and (max-width: 320px) {
    padding-right: 5px;
  }
`;
export const PageBreak = styled.div`
  @media print {
    page-break-before: always;
  }
`;



// WEBPACK FOOTER //
// ./src/screens/CompareProject/styled.js